import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
    primary: {},
    secondary: {},

    label: {
        ...theme.typographyPresets.labelPrimary,
    },
    input: {
        width: '100%',
        height: '36px',
        padding: '10px',
        borderRadius: '2px',

        '&$primary': {
            '&:focus': {
                outline: 'transparent',
                border: 'solid 1px #f73153',
            },
        },

        '&$secondary': {
            background: 'rgba(255, 255, 255, 0.08)',
            paddingTop: 22,
            paddingBottom: 22,
            paddingLeft: 16,
            borderRadius: 6,
            border: '1px solid rgba(255, 255, 255, 0.2)',
            transition: 'background .2s ease-in-out',

            '&:-webkit-autofill,  &:-webkit-autofill:hover,  &:-webkit-autofill:focus': {
                '-webkit-text-fill-color': theme.colors.white,
                '-webkit-box-shadow': '0 0 0px 1000px rgba(255, 255, 255, 0.04) inset',
                transition: 'background-color 5000s ease-in-out 0s',
                border: '1px solid rgba(255, 255, 255, 0.2)',
            },
            '&:focus, &:hover': {
                background: 'rgba(255, 255, 255, 0.12)',
            },
        },
    },
    formCtrl: {
        margin: '10px 0',
    },
    error: {
        ...theme.typographyPresets.labelPrimary,
        display: 'flex',
        alignItems: 'center',
        color: theme.colors.brand.pink,
        margin: '10px 2px',
    },
    errorIcon: {
        color: theme.colors.brand.pink,
        marginRight: 8,
    },
    labelContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    infoContainer: {
        position: 'relative',
    },
    info: {
        fontSize: '14px',
        color: 'black',
    },

    tooltip: {
        position: 'absolute',
        top: '50%',
        right: '20px',
        fontSize: '11px',
        transform: 'translateY(-50%)',
        color: 'white',
        background: 'black',
        padding: '5px',
        borderRadius: '3px',
        '&:before': {
            position: 'absolute',
            content: "''",
            borderColor: 'transparent',
            borderStyle: 'solid',
        },
    },
    dark: {
        color: `${theme.colors.white} !important`,
        backgroundColor: theme.colors.dark.dark2,
        borderRadius: '2px',
        border: 'solid 1px #5e6675',
    },
    light: {
        color: `${theme.colors.black} !important`,
        backgroundColor: theme.colors.white,
        borderRadius: '2px',
    },

    infoDark: {
        fontSize: '14px',
        color: theme.colors.white,
        position: 'absolute',
        top: '8px',
        marginRight: '25px',
    },
    inputContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row-reverse',
    },
}))
